export default {
  ru: {
    menu: {
      title_1: 'Привлечение клиентов',
      title_2: 'Создание команды',
      title_3: 'Подключение бизнесов',
      btn: 'Зарегистрироваться',
      login: 'Войти'
    },
    title: 'WWP Capital&nbsp;&mdash; партнерское сообщество, созданное для продвижения <nobr>IT-продуктов</nobr> и&nbsp;сервисов.',
    dsc: 'Партнерское сообщество WWP Capital&nbsp;&mdash; это прочная основа для вашего бизнеса. Мы&nbsp;предоставляем уникальные ресурсы, форматы и&nbsp;программы для построения бизнеса с&nbsp;нуля.'

  },
  en: {
    menu: {
      title_1: 'Attracting customers',
      title_2: 'Creating a team',
      title_3: 'Connecting stores',
      btn: 'Sign up',
      login: 'Sign in'
    },
    title: `WWP Capital is&nbsp;a&nbsp;partner community created to&nbsp;promote&nbsp;IT products and services.`,
    dsc: `The WWP Capital Partnership Community is&nbsp;a&nbsp;solid foundation for your business. We&nbsp;provide unique resources, formats and programs for building a&nbsp;business from scratch.`
  },
  ua: {
    menu: {
      title_1: 'Залучення клієнтів',
      title_2: 'Створення команди',
      title_3: 'Підключення бізнесів',
      btn: 'Зареєструватися',
      login: 'Увійти'
    },
    title: `WWP Capital&nbsp;&mdash; партнерське співтовариство, створене для просування IT-продуктів і&nbsp;сервісів.`,
    dsc: `Партнерське співтовариство WWP Capital&nbsp;&mdash; це&nbsp;міцна основа для вашого бізнесу. Ми&nbsp;надаємо унікальні ресурси, формати і&nbsp;програми для побудови бізнесу з&nbsp;нуля.`
  },
  kz: {
    menu: {
      title_1: 'Клиенттерді тарту',
      title_2: 'Команда құру',
      title_3: 'Іскерлік байланыс',
      btn: 'Тіркелу',
      login: 'Кіру'
    },
    title: 'WWP Capital&nbsp;&mdash; <nobr>IT-өнімдер</nobr> мен сервистерді жылжыту үшін құрылған серіктестік қауымдастық.',
    dsc: 'WWP Capital серіктестік қауымдастығы-Сіздің бизнесіңіз үшін берік негіз. Біз бизнесті нөлден бастап құру үшін бірегей ресурстарды, форматтар мен бағдарламаларды ұсынамыз.'
  }
}
